/* import __COLOCATED_TEMPLATE__ from './identity.hbs'; */
var _class;
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
import { TextField } from 'field-kit';
import { action } from '@ember/object';
import Component from '@ember/component';
import assert from '@banking/ui/utils/assert';
import USDateFormatter from '@banking/ui/utils/field-kit-formatters/us-date-formatter';
import { DATE_OF_BIRTH_FIELD_IDENTIFIER } from '@banking/ui/models/checking/onboarding/identity';
import { FieldIdentifier as AddressFieldIdentifier } from '@banking/ui/models/common/address';
let Identity = (_class = class Identity extends Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "tagName", '');
    _defineProperty(this, "DATE_OF_BIRTH_FIELD_IDENTIFIER", DATE_OF_BIRTH_FIELD_IDENTIFIER);
    // arguments
    _defineProperty(this, "onValueChange", () => {});
    _defineProperty(this, "onNextButtonClick", void 0);
    _defineProperty(this, "initialDateOfBirth", void 0);
  }
  _onAddressValueChange(fieldCandidate, valueCandidate) {
    assert(fieldCandidate != null && typeof fieldCandidate === 'string' && fieldCandidate in AddressFieldIdentifier);
    // FIXME(steckel): Find a way to type-narrow over type-casting
    const field = fieldCandidate;
    assert(typeof valueCandidate === 'string');
    // FIXME(steckel): Find a way to type-narrow over type-casting
    const value = valueCandidate;
    this.onValueChange({
      field,
      value
    });
  }
  async initializeFieldKit(marketInputTextElement) {
    const inputElement = await marketInputTextElement.getInputElement();
    const formatter = new USDateFormatter();
    if (this.initialDateOfBirth) {
      // eslint-disable-next-line require-atomic-updates
      marketInputTextElement.value = formatter.format(this.initialDateOfBirth);
    }
    const fieldKit = new TextField(inputElement, formatter);
    const textDidChange = field => {
      const value = field.value();
      this.onValueChange({
        field: DATE_OF_BIRTH_FIELD_IDENTIFIER,
        value
      });
    };
    fieldKit.setDelegate({
      textDidChange
    });
  }
}, _applyDecoratedDescriptor(_class.prototype, "_onAddressValueChange", [action], Object.getOwnPropertyDescriptor(_class.prototype, "_onAddressValueChange"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "initializeFieldKit", [action], Object.getOwnPropertyDescriptor(_class.prototype, "initializeFieldKit"), _class.prototype), _class);
export { Identity as default };